import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-bd8d8a32")
const _hoisted_1 = { class: "flex justify-start space-x-2" }
const _hoisted_2 = { class: "flex space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Volume ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TVL ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Fees ")
const _hoisted_6 = { class: "dark:text-white" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_vue_apex_charts = _resolveComponent("vue-apex-charts")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBlankSlate = _resolveComponent("BalBlankSlate")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    "no-content-pad": "",
    class: "px-4 pt-4"
  }, {
    default: _withCtx(() => [
      (_ctx.snapshots.length > 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_BalBtn, {
                  class: _normalizeClass(['toggle-button', _ctx.currentChartType === 'volume' ? 'toggle-button-active' : '']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentChart('volume')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_BalBtn, {
                  class: _normalizeClass(['toggle-button', _ctx.currentChartType === 'tvl' ? 'toggle-button-active' : '']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentChart('tvl')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_BalBtn, {
                  class: _normalizeClass(['toggle-button', _ctx.currentChartType === 'fees' ? 'toggle-button-active' : '']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentChart('fees')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ]),
            _createVNode(_component_vue_apex_charts, {
              type: "area",
              height: "350",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"])
          ], 64))
        : (_openBlock(), _createBlock(_component_BalBlankSlate, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_BalIcon, { name: "bar-chart" }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('insufficientData')), 1)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}